<template>
	<div class="news">
		<v-row justify="start">
			<v-col v-for="(article) in updates" :key="article.id" md="5">
				<a v-if="article.link" :href="article.link">
					<news-card :news="article"/>
				</a>
				<news-card v-else :news="article"/>
			</v-col>
		</v-row>
	</div>
</template>

<script>


	// </v-col>
	import NewsCard from "dev/view/home/NewsCard";


	export default {
		name: "news",
		components: {NewsCard},
		computed: {
			updates() {
				return this.$store.state.UpdateModule.updates.filter(update => update.type === "square" && update.active);
			},
		}
	};
</script>

<style scoped>
	a {
		text-decoration: none;
	}

	.news {
		margin: 0 15px;
	}

	.date-container {
		font-size: 14px;
		margin-bottom: 20px;
		color: #dfdddd;
	}

	.contebt {
		color: #0694d4;
	}
</style>
